<p-fieldset legend="Licitantes">
  <div class="row">
    <label class="required col-12 col-form-label">
      Existem Licitantes?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12" [(ngModel)]="entidade.LicitanteNao"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <lib-licitacao-audesp-licitante-cnpj *ngIf="entidade.LicitanteNao === 'S'" [entidade]="entidade">
  </lib-licitacao-audesp-licitante-cnpj>
  <lib-licitacao-audesp-licitante-cpf *ngIf="entidade.LicitanteNao === 'S'" [entidade]="entidade">
  </lib-licitacao-audesp-licitante-cpf>
  <lib-licitacao-audesp-licitante-estrangeiro *ngIf="entidade.LicitanteNao === 'S'" [entidade]="entidade">
  </lib-licitacao-audesp-licitante-estrangeiro>
</p-fieldset>